export const INIT_BBOX_IMAGE_DATA='INIT_BBOX_IMAGE_DATA';
export const GRAB_BBOX_IMAGE_DATA='GRAB_BBOX_IMAGE_DATA';
export const GRAB_BBOX_IMAGE_DATA_ERROR='GRAB_BBOX_IMAGE_DATA_ERROR';


// WEBPACK FOOTER //
// ./src/redux/boundingBox/actionTypes.js